/* Emir ICE — panier : mini-panier de l'en-tête + page /cart (refonte, 2026-10-14)
   Balisage : snippets/eix-cart-*.liquid (rendu serveur). Style : assets/eix-cart.css. Chargé depuis sections/header.liquid.

   Principe : le HTML des lignes, des prix (format français), du récapitulatif, de la barre « livraison offerte » est TOUJOURS fabriqué par Shopify
   (Liquid) ; après chaque changement du panier on redemande la section concernée à l'API de rendu de sections
   (/?section_id=header pour le mini-panier, /cart?section_id=cart-template pour la page) et on remplace le contenu. Rendu serveur et rendu après
   Ajax sont donc identiques (mêmes prix, mêmes propriétés masquées, mêmes délais) et aucun prix n'est recalculé en JavaScript.

   Changements gérés ici (+, −, saisie, suppression) : POST /cart/change.js. Les anciens gestionnaires du thème (js-change-quantity,
   data-remove-item, refreshCart d'app.js, avec ses requêtes synchrones) ne sont plus sollicités : les crochets du thème ne sont pas posés dans le balisage.
   Si un autre code (ajout au panier du thème, Vanga, emir-perso) change le panier, on le voit passer (fetch / XMLHttpRequest sur /cart/add|change|update|clear)
   et on rafraîchit à notre tour. emir-chaine-cart.js n'est pas modifié : il garde ses appels (fetch d'origine, non détectables), donc on rafraîchit
   une seconde fois ~1,6 s après un changement pour voir la chaîne suivre la quantité du bijou.
   InstantClick : écouteurs globaux posés une seule fois ; init() se rejoue à chaque page.
   2026-11-03 : bouton « Ajouter » de la pièce assortie ([data-eix-offre-add], voir plus bas). */
(function () {
  'use strict';
  if (window.__eixCart) { window.__eixCart.init(); return; }

  var doc = document;
  var RX = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  var S = { timer: 0, timer2: 0, busy: false, again: false, focusKey: null, obs: [] };

  function qa(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function closest(el, sel) { return el && el.closest ? el.closest(sel) : null; }
  var origFetch = window.fetch ? window.fetch.bind(window) : null;

  /* ---------- rafraîchissement depuis le rendu serveur ---------- */
  /* racine de la langue courante (« / », « /en/ », « /pt/ »…) : le rendu de section suit la langue de l'adresse (relecture du 03/11) */
  function racine() { var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; return r.charAt(r.length - 1) === '/' ? r : r + '/'; }

  function getHtml(url) {
    var sep = url.indexOf('?') >= 0 ? '&' : '?';
    return (origFetch || window.fetch)(url + sep + '_=' + Date.now(), { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
      .then(function (t) { return new DOMParser().parseFromString(t, 'text/html'); });
  }

  function refreshMini() {
    return getHtml(racine() + '?section_id=header').then(function (d) {
      var src = d.querySelector('.cart_container .cart_content');
      var cnt = d.querySelector('.cart_container .cart_count');
      if (cnt) qa('.cart_count').forEach(function (c) { c.textContent = cnt.textContent; });
      if (!src) return;
      qa('.cart_container .cart_content').forEach(function (box) {
        var note = box.querySelector('textarea[name="note"]');
        var val = note ? note.value : null;
        var open = box.querySelector('details.eix-note[open]');
        box.innerHTML = src.innerHTML;
        var n2 = box.querySelector('textarea[name="note"]');
        if (n2 && val) { n2.value = val; var det = closest(n2, 'details'); if (det) det.open = true; }
        else if (n2 && open) { var det2 = closest(n2, 'details'); if (det2) det2.open = true; }
      });
      qa('.js-cart_items.is-wait').forEach(function (l) { l.classList.remove('is-wait'); });
      watch(); /* la liste vient d'être remplacée : l'observateur doit suivre la nouvelle (contre-vérification du 03/11) */
    });
  }

  function refreshPage() {
    var root = doc.getElementById('eix-cart-root');
    if (!root) return Promise.resolve();
    return getHtml(racine() + 'cart?section_id=cart-template').then(function (d) {
      var neu = d.getElementById('eix-cart-root');
      if (!neu) return;
      root.innerHTML = neu.innerHTML;
      restoreFocus(root);
    });
  }

  function restoreFocus(root) {
    var k = S.focusKey;
    S.focusKey = null;
    if (!k) return;
    var li = root.querySelector('[data-eix-key="' + k.key + '"]');
    var el = li ? li.querySelector(k.sel) : null;
    if (!el) el = root.querySelector('.eix-cart__h');
    if (el) { if (!el.hasAttribute('tabindex') && el.tagName === 'H1') el.setAttribute('tabindex', '-1'); try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
  }

  function refreshAll() {
    if (S.busy) { S.again = true; return Promise.resolve(); }
    S.busy = true;
    qa('[data-eix-root], .eix-mini').forEach(function (r) { r.setAttribute('aria-busy', 'true'); });
    return Promise.all([refreshMini().catch(function () {}), refreshPage().catch(function () {})]).then(function () {
      S.busy = false;
      qa('[data-eix-root], .eix-mini').forEach(function (r) { r.removeAttribute('aria-busy'); });
      if (S.again) { S.again = false; setTimeout(refreshAll, 60); }
    });
  }

  function schedule(delay) {
    clearTimeout(S.timer);
    S.timer = setTimeout(refreshAll, delay == null ? 150 : delay);
  }
  /* seconde passe : la chaîne compagnon est resynchronisée par emir-chaine-cart.js ~0,5 s après un changement */
  function schedule2() {
    clearTimeout(S.timer2);
    S.timer2 = setTimeout(refreshAll, 1600);
  }

  /* ---------- changement d'une ligne ---------- */
  function changeLine(li, qty, focusSel) {
    var line = parseInt(li.getAttribute('data-eix-line'), 10);
    if (!line || qty < 0 || isNaN(qty)) return;
    S.focusKey = { key: li.getAttribute('data-eix-key'), sel: focusSel };
    li.classList.add('is-busy');
    qa('input, button', li).forEach(function (c) { c.disabled = true; });
    /* window.fetch AU MOMENT de l'appel (et non la copie prise au chargement) : emir-chaine-cart.js, chargé après ce fichier, enveloppe window.fetch ;
       c'est ainsi qu'il voit le changement et resynchronise la chaîne compagnon sur la quantité du bijou (comportement inchangé). */
    window.fetch('/cart/change.js', {
      __eix: true, method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function () { refreshAll(); schedule2(); })
      .catch(function () { li.classList.remove('is-busy'); qa('input, button', li).forEach(function (c) { c.disabled = false; }); schedule(0); });
  }

  function lineOf(el) { return closest(el, '[data-eix-line]'); }
  function qtyOf(li) { var i = li.querySelector('[data-eix-q]'); var v = i ? parseInt(i.value, 10) : NaN; return isNaN(v) ? 1 : v; }

  doc.addEventListener('click', function (e) {
    var t = e.target;
    var plus = closest(t, '[data-eix-plus]'), minus = closest(t, '[data-eix-minus]'), x = closest(t, '[data-eix-x]');
    var el = plus || minus || x;
    if (!el) return;
    var li = lineOf(el);
    if (!li) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    if (plus) changeLine(li, qtyOf(li) + 1, '[data-eix-plus]');
    else if (minus) changeLine(li, Math.max(0, qtyOf(li) - 1), '[data-eix-minus]');
    else changeLine(li, 0, '[data-eix-q]');
  }, true);

  doc.addEventListener('change', function (e) {
    var inp = closest(e.target, '[data-eix-q]');
    if (!inp) return;
    var li = lineOf(inp);
    if (!li) return;
    e.stopPropagation(); e.stopImmediatePropagation();
    var v = parseInt(inp.value, 10);
    if (isNaN(v) || v < 0) v = 1;
    changeLine(li, v, '[data-eix-q]');
  }, true);

  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && closest(e.target, '[data-eix-q]')) { e.preventDefault(); e.target.blur(); }
  }, true);

  /* ---------- pièce assortie (snippets/eix-offre-panier.liquid, 2026-11-03) ----------
     « Ajouter » : la variante proposée part avec la propriété cachée _eix_offre = panier (mesure dans les commandes, jamais affichée au client).
     Le panier se redessine ensuite depuis le rendu serveur : la suggestion disparaît d'elle-même (une seule par panier). */
  doc.addEventListener('click', function (e) {
    var b = closest(e.target, '[data-eix-offre-add]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    if (b.disabled) return;
    var id = parseInt(b.getAttribute('data-eix-offre-add'), 10);
    if (!id) return;
    var box = closest(b, '[data-eix-offre]');
    var err = box ? box.querySelector('[data-eix-offre-err]') : null;
    var jumeaux = qa('[data-eix-offre-add="' + id + '"]');
    jumeaux.forEach(function (x) { x.disabled = true; });
    if (box) { box.classList.add('is-busy'); box.setAttribute('aria-busy', 'true'); }
    if (err) err.hidden = true;
    window.fetch('/cart/add.js', {
      __eix: true, method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1, properties: { _eix_offre: 'panier' } }] })
    }).then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function () { refreshAll(); schedule2(); })
      .catch(function () {
        jumeaux.forEach(function (x) { x.disabled = false; });
        if (box) { box.classList.remove('is-busy'); box.removeAttribute('aria-busy'); }
        if (err) { var msg = err.textContent; err.textContent = ''; err.hidden = false; setTimeout(function () { err.textContent = msg; }, 60); }
      });
  }, true);

  /* ---------- autres sources de changement du panier ---------- */
  if (origFetch) {
    window.fetch = function (input, init) {
      var url = '';
      try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
      var p = origFetch(input, init);
      if (url && RX.test(url) && !(init && init.__eix)) { p.then(function () { schedule(250); schedule2(); }, function () {}); }
      return p;
    };
  }
  if (window.XMLHttpRequest) {
    var oo = XMLHttpRequest.prototype.open, os = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { try { this.__eixUrl = String(u); } catch (e) {} return oo.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      if (this.__eixUrl && RX.test(this.__eixUrl)) this.addEventListener('loadend', function () { schedule(250); schedule2(); });
      return os.apply(this, arguments);
    };
  }

  /* repli : si le thème (refreshCart d'app.js) réécrit la liste avec son balisage, on la masque et on remet le rendu serveur */
  function watch() {
    S.obs.forEach(function (o) { try { o.disconnect(); } catch (e) {} });
    S.obs = [];
    if (!window.MutationObserver) return;
    qa('.js-cart_items').forEach(function (list) {
      var o = new MutationObserver(function () {
        if (list.children.length && !list.querySelector('.eix-cl')) { list.classList.add('is-wait'); schedule(0); }
      });
      o.observe(list, { childList: true });
      S.obs.push(o);
    });
  }

  function init() {
    clearTimeout(S.timer); clearTimeout(S.timer2);
    S.busy = false; S.again = false;
    watch();
  }

  window.__eixCart = { init: init, refresh: refreshAll };
  function boot() {
    init();
    doc.addEventListener('instantclick:newpage', init);
    if (window.InstantClick && typeof window.InstantClick.on === 'function') { try { window.InstantClick.on('change', init); } catch (e) {} }
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
})();
